export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export type User = {
  id: string
  username: string
  email: string
  role: Role
  profile?: {
    name: string
    country?: string
    membershipType?: string
  }
}
